import templateHtml from './subscriber-picker.html';

const component = {};

component.template = templateHtml;

component.bindings = {    
    visible: '=',
    subscribers: '<',
    modalTitle: '<',
    bodyText: '<',
    loginSubscriberCallback: '&',
    onCloseCallback: '&',
    useLoadingBehavior: '<'
};

component.controllerAs = 'vm';

function SubscriberPickerController() {
    const vm = this;
    vm.isLoading = false;
    vm.selectedSubscriberId = null;
    
    vm.onCancelClick = function onCancelClick() {
        if (!vm.isLoading) {
            vm.visible = false;
            vm.onCloseCallback();
        }
    };

    vm.onOverlayClick = function onOverlayClick() {
        // Do nothing here. We don't want users to be able to close the modal when clicking outside it.
    };

    vm.logInSubscriber = function logInSubscriber(subscriber) {
        if (!subscriber.IsBlocked && !vm.isLoading) {
            vm.selectedSubscriberId = subscriber.UserId;
            if (vm.useLoadingBehavior) {
                vm.isLoading = true;
            }
            vm.loginSubscriberCallback({subscriber});
        }
    };
}

SubscriberPickerController.$inject = [];
component.controller = SubscriberPickerController;
export const SubscriberPickerComponent = component;
